import styled from 'styled-components'
import {
  default as VARIABLES
} from './../../../themes/styles/bases/variables'

export const LoadingWrapper = styled.div`
  /* Parent
  ------------------------------- */
  pointer-events: none;
  transition: ${VARIABLES.TRANSITIONS.DEFAULT};
  opacity: 0;
  position: fixed;
  z-index: ${VARIABLES.Z_INDEXS.LV_8};
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${VARIABLES.COLORS.OVERLAY_BLACK_1};

  /* Childrens
  ------------------------------- */
  /* Modifiers
  ------------------------------- */
  &.is-active {
    pointer-events: auto;
    opacity: 1;
  }

  /* Media queries
  ------------------------------- */
`
